<template>
    <section class="content">
        <!-- <div v-if="isAreaTable" class="password-popup">
            <div class="password-popup-width">
                <a class="toggle" v-on:click="closeAreaTableModal">
                    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" x="0" y="0" version="1.1" viewBox="0 0 29 29" xml:space="preserve">
                        <path fill="none" stroke="#706c6c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M9.197 19.803L19.803 9.197M9.197 9.197l10.606 10.606" />
                    </svg>
                </a>
                <h4 class="heading_pop">Waste Collection Areas of {{ plantName }}</h4>
                <div class="table_scroll">
                    <table class="tablePopUp">
                        <tr>
                            <th>Area Name</th>
                            <th>Area Location</th>
                        </tr>
                        <tr v-for="data in tableDataNew">
                            <td>{{ data.areaName }}</td>
                            <td>{{ data.areaLocation }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div> -->
    
        <div v-on:click="closeAreaTableModal">
            <div class="box-body">
                <!-- v-permission.if="['addCity']" -->
                <div :class="addButtonClass">
                    <router-link :to="{ name: 'wasteSegregationCreate' }">
                        <button class=" btn gradientbt">Add Waste Segregation</button>
                    </router-link>
                </div>
    
                <v-server-table ref="wasteSegregationTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
                    <template slot="beforeBody">
                        <tr v-if="loading" class="VueTables__no-results">
                            <td class="text-center" colspan="6">
                                <pulse-loader></pulse-loader>
                            </td>
                        </tr>
                    </template>
                    <template slot="action" slot-scope="props">
                        <div class="active_wrp">
                            <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>
                            <div class="py-2 text-center row">
                                <label class="toggle">
                                    <input class="toggle-checkbox" type="checkbox" :checked="props.row.isActive" @click.prevent="(e) => activateSegregationModal(props.row)" />
                                    <span class="slider"></span>
                                    <span class="labels" data-on="Active" data-off="Deactivate"></span>
                                </label>
                            </div>
                        </div>
                    </template>
                    <template slot="wasteCollectionAreaCount" slot-scope="props">
                        <div class="active_wrp">
                            <a role="button" v-if="props.row.wasteCollectionAreaCount" v-on:click.stop="showArea(props.row)">{{ props.row.wasteCollectionAreaCount }}</a>
                            <p v-if="!props.row.wasteCollectionAreaCount">
                                {{ props.row.wasteCollectionAreaCount }}
                            </p>
                        </div>
                    </template>
                   
                </v-server-table>
            </div>
        </div>
    </section>
    </template>
    
    <script>
    import {
        eventBus,
        segregationService
    } from "../../../services";
    import {
        USER_ROLES
    } from "../../../config";
    import {
        ServerTable,
        Event
    } from "vue-tables-2";
    import {
        mapState
    } from "vuex";
    
    import store from "../../../store";
    import swal from "sweetalert2";
    import moment from "moment";
   
    import dateFormatter from "../../utilities/dateFormate";
    
    
    export default {
        name: "wasteSegregation",
        plantName: null,
        data() {
            return {
                tableDataNew: [],
                isAreaTable: false,
                loading: null,
                USER_ROLES: USER_ROLES,
                wasteSegregationTable: null,
                columns: [
                    "spName",                
                    "totalWaste",
                    "categories",
                    "status",
                    "completionDate",
                    "createdAt",
                    "action",
                ],
             
                options: {
                    highlightMatches: true,
                    headings: {
                        spName: "SP Name",                   
                        totalWaste: "Total Waste[KG]",
                        categories: "Categories",
                        status: "Status",
                        completionDate: "Completion Date",
                        createdAt: "Created On",
                        action: "Action",
                    },
                    templates: {
                        createdAt(row, query) {
                            return dateFormatter(query.createdAt);                           
                        },
                      
                    },
                    perPage: 10,
                    sortable: [
                    "spName",                
                    "totalWaste",
                    "categories",
                    "status",
                    "completionDate",
                    "createdAt",
                   
                    ],
                    requestFunction: (request) => {
                        const params = {};
                        params.page = request.page;
                        params.limit = request.limit;
                        if (request.orderBy) {
                            params.sortBy = request.orderBy;
                        }
                        if (request.ascending == 1) {
                            params.sortOrder = "asc";
                        } else {
                            params.sortOrder = "des";
                        }
                        if (request.query.status) {
                            params.status = request.query.status;
                        }
                        if (request.query) {
                            params.searchString = request.query;
                        }
    
                        this.loading = true;
    
                        return this.$wasteSegregationDataRepository
                            .list(params)
                            .catch((error) => {
                                console.error("Users.requestFunction-error:", error);
                            });
                    },
    
                    responseAdapter: (response) => {
                        this.loading = false;
                                             
                        const data = response.data.docs
    
                        return {
                            data: data,
                            count: response.data.items.total,
                        };
                    },
    
                    customFilters: [{
                        name: "custom_filter",
                        callback: function (row, query) {
                            //	return row.role[0] == query;
                        },
                    }, ],
                    uniqueKey: "_id",
                },
            };
        },
        computed: {
            addButtonClass() {
                if (this.wasteSegregationTable) {
                    return this.wasteSegregationTable.count > this.wasteSegregationTable.limit ||
                        this.wasteSegregationTable.limit > 10 ?
                        "shift-add-left" :
                        "add-item";
                } else {
                    return "add-item";
                }
            },
            ...mapState({
                user: (state) => state.auth.user,
            }),
        },
        methods: {
            closeAreaTableModal() {
                if (this.isAreaTable) {
                    this.isAreaTable = !this.isAreaTable;
                }
            },
            showArea(row) {
                return segregationService
                    .wasteCollectionArea(row._id)
                    .then((response) => {
                        this.plantName = response.data.plantName;
                        this.tableDataNew = response.data.wasteCollectionArea;
                        this.isAreaTable = true;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error("Segregation.ShowArea-error:", error);
                        this.$snotify.error("Show Area failed", "Error!");
                    });
            },
           
    
            action(row) {
                this.$router.push({
                    name: "segregationPlantCreate",
                    params: {
                        _id: row._id,
                    },
                    props: row,
                });
            },
       
            onLoaded() {
                this.wasteSegregationTable = this.$refs.wasteSegregationTable;
            },
            clearFilter() {
                this.custom_filter_select = "";
            },
            applyFilter(filter_val) {
                Event.$emit("vue-tables.customFilters::custom_filter", filter_val);
            },
        },
        mounted() {
            eventBus.$on("DATA_PUBLISHED", (payload) => {});
        },
    };
    </script>
    
    <style scoped>
    .sorting {
        position: absolute;
        left: 319px;
        z-index: 1000;
        width: 200px;
    }
    
    .box-body {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .gradientbt {
        background: #35A2FE;
        color: white;
    }
    
    /* new css */
    
    .toggle {
        --width: 64px;
        --height: calc(var(--width) / 3);
    
        position: relative;
        display: inline-block;
        width: var(--width);
        height: var(--height);
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
        border-radius: var(--height);
        cursor: pointer;
        margin-bottom: 0px;
        position: relative;
        top: 2px;
    }
    
    .toggle input {
        display: none;
    }
    
    .toggle .slider {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: var(--height);
        background-color: #ccc;
        transition: all 0.4s ease-in-out;
    }
    
    .toggle .slider::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: calc(var(--height));
        height: calc(var(--height));
        border-radius: calc(var(--height) / 2);
        background-color: #fff;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
        transition: all 0.4s ease-in-out;
    }
    
    .toggle input:checked+.slider {
        background-color: #35A2FE;
    }
    
    .toggle input:checked+.slider::before {
        transform: translateX(calc(var(--width) - var(--height)));
    }
    
    .toggle .labels {
        position: absolute;
        top: 4px;
        left: 0;
        width: 100%;
        height: 100%;
        font-size: 10px;
        font-family: sans-serif;
        transition: all 0.4s ease-in-out;
    }
    
    .toggle .labels::after {
        content: attr(data-off);
        position: absolute;
        right: 5px;
        color: #4d4d4d;
        opacity: 1;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
        transition: all 0.4s ease-in-out;
    }
    
    .toggle .labels::before {
        content: attr(data-on);
        position: absolute;
        left: 5px;
        color: #ffffff;
        opacity: 0;
        text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
        transition: all 0.4s ease-in-out;
    }
    
    .toggle input:checked~.labels::after {
        opacity: 0;
    }
    
    .toggle input:checked~.labels::before {
        opacity: 1;
    }
    
    .active_wrp {
        display: flex;
        align-items: center;
    }
    
    .active_wrp a {
        flex: 0 0 30%;
        color: #35A2FE;
        margin-right: 10px;
    }
    
    .password-popup {
        height: 100%;
        width: 100%;
        z-index: 10;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        text-align: center;
        box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
        z-index: 9999;
        background-color: rgb(0 0 0 / 50%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .tablePopUp {
        border-collapse: collapse;
        border: 1px solid black;
        table-layout: auto;
        width: 460px;
    }
    
    .table_scroll {
        height: 200px;
        overflow: auto;
        padding: 0px 10px;
        overflow-x: hidden;
    }
    
    /* width */
    .table_scroll::-webkit-scrollbar {
        width: 5px;
    }
    
    /* Track */
    .table_scroll::-webkit-scrollbar-thumb {
        background: #888;
    }
    
    .password-popup-width h1 {
        font-size: 22px;
        margin-bottom: 10px;
        font-weight: 600;
    }
    
    th,
    td {
        border: 1px solid black;
        padding: 5px;
        text-align: left;
    }
    
    .loginForm {
        padding-top: 0px;
    }
    
    .password-popup h2 {
        margin: 0;
        font-size: 24px;
        margin-bottom: 20px;
        text-align: center;
    }
    
    .cancelButton {
        background-color: #f44336;
        border-radius: 8px;
        left: 47%;
        position: fixed;
        bottom: 100px;
    }
    
    .password-popup-width {
        padding-top: 0px;
        background: #fff;
        width: 500px;
        height: 300px;
        padding: 0px;
        border-radius: 10px;
        position: relative;
    }
    
    .password-popup-width .toggle {
        box-shadow: none;
        border: none;
        width: auto;
        position: absolute;
        right: 10px;
        top: 20px;
    }
    
    .password-popup-width .toggle svg {
        width: 22px;
        height: 22px;
    }
    
    h4.heading_pop {
        background: #f1f1f1;
        padding: 20px;
        margin: 0;
        border-bottom: 1px solid #ddd;
        text-align: left;
        margin-bottom: 10px;
        border-radius: 5px 5px 0px 0px;
    }
    </style>
    


// WEBPACK FOOTER //
// wasteSegregation.vue?d1472582